import { FormlyTemplateOptions } from '@ngx-formly/core';
import { IConditionalOption } from './field';
import { IObject, Tip } from './object';

export interface NogginTemplateOptions extends FormlyTemplateOptions {
  appearance?: string;
  autosize?: boolean;
  contextTypeTip?: string | null;
  i18n_label?: {};
  i18n_title?: {};
  i18n_placeholder?: {};
}

export interface IFormField extends IObject {
  key?: string;
  type: string;
  templateOptions: NogginTemplateOptions;
  objectSchemaProperties?: {};
  validators?: {};
  conditionalFields?: {
    [key: string]: IConditionalOption;
  };
}

export interface IFormRow {
  fields: IFormField[];
}

export interface IFormTab {
  tabName: string;
  i18n_tabName?: {};
  rows: IFormRow[];
}

export enum Position {
  LEFT_ALIGNED = 'Left-aligned',
  CENTERED = 'Centered',
  RIGHT_ALIGNED = 'Right-aligned',
  NO_LOGO = 'No logo'
}

export interface IPublicForm extends IObject {
  tip?: Tip;
  name: string;
  tabs: IFormTab[];
  formSpecVersion?: string;
  logo?: string;
  background?: string;
  logoPositioning?: Position;
  contextTypeTitle?: string;
}
